module.exports = __webpack_public_path__ + "img/poster-index-2.5f194906.jpg";